"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.likeRelations = exports.notificationRelations = exports.messageRelations = exports.commentRelations = exports.postRelations = exports.userRelations = exports.data = exports.likes = exports.notifications = exports.messages = exports.comments = exports.posts = exports.sessions = exports.users = exports.drizzle = void 0;
const drizzle_orm_1 = require("drizzle-orm");
const sqlite_core_1 = require("drizzle-orm/sqlite-core");
exports.drizzle = __importStar(require("drizzle-orm"));
const NOTIFICATION_TYPES = ['comment', 'message', 'like', 'follow', 'mention', 'post', 'post-comment', 'post-like', 'post-mention'];
const REACTIONS = ['👍', '❤️', '😂', '😢', '😡', '😮', '😭'];
const ROLES = ['admin', 'user'];
exports.users = (0, sqlite_core_1.sqliteTable)('users', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    name: (0, sqlite_core_1.text)('name').notNull(),
    email: (0, sqlite_core_1.text)('email'),
    password: (0, sqlite_core_1.text)('password'),
    passcheck: (0, sqlite_core_1.text)('passcheck'),
    emoji: (0, sqlite_core_1.text)('emoji'),
    last_login: (0, sqlite_core_1.text)('last_login'),
    fingerprint: (0, sqlite_core_1.text)('fingerprint'),
    role: (0, sqlite_core_1.text)('role', { enum: ROLES }).notNull().default('user'),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.sessions = (0, sqlite_core_1.sqliteTable)('sessions', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    userId: (0, sqlite_core_1.int)('user_id').references(() => exports.users.id),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.posts = (0, sqlite_core_1.sqliteTable)('posts', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    slug: (0, sqlite_core_1.text)('slug').notNull().unique(),
    userId: (0, sqlite_core_1.int)('user_id').references(() => exports.users.id),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    title: (0, sqlite_core_1.text)('title').notNull(),
    content: (0, sqlite_core_1.text)('content'),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.comments = (0, sqlite_core_1.sqliteTable)('comments', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    postId: (0, sqlite_core_1.int)('post_id').references(() => exports.posts.id),
    userId: (0, sqlite_core_1.int)('user_id').references(() => exports.users.id),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    content: (0, sqlite_core_1.text)('content'),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.messages = (0, sqlite_core_1.sqliteTable)('messages', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    subject: (0, sqlite_core_1.text)('subject').notNull(),
    from: (0, sqlite_core_1.int)('from').references(() => exports.users.id),
    to: (0, sqlite_core_1.int)('to').references(() => exports.users.id),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    content: (0, sqlite_core_1.text)('content'),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.notifications = (0, sqlite_core_1.sqliteTable)('notifications', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    userId: (0, sqlite_core_1.int)('user_id').references(() => exports.users.id),
    type: (0, sqlite_core_1.text)('type', { enum: NOTIFICATION_TYPES }).notNull(),
    link: (0, sqlite_core_1.text)('link'),
    linkText: (0, sqlite_core_1.text)('link_text'),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    content: (0, sqlite_core_1.text)('content'),
    metadata: (0, sqlite_core_1.text)('metadata')
});
exports.likes = (0, sqlite_core_1.sqliteTable)('likes', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    reaction: (0, sqlite_core_1.text)('reaction', { enum: REACTIONS }).notNull(),
    userId: (0, sqlite_core_1.int)('user_id').references(() => exports.users.id),
    postId: (0, sqlite_core_1.int)('post_id').references(() => exports.posts.id),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
});
exports.data = (0, sqlite_core_1.sqliteTable)('data', {
    id: (0, sqlite_core_1.int)('id').primaryKey(),
    site: (0, sqlite_core_1.text)('site').notNull(),
    name: (0, sqlite_core_1.text)('name').notNull(),
    value: (0, sqlite_core_1.text)('value').notNull(),
    createdAt: (0, sqlite_core_1.text)('created_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    updatedAt: (0, sqlite_core_1.text)('updated_at').notNull().default((0, drizzle_orm_1.sql) `(current_timestamp)`),
    metadata: (0, sqlite_core_1.text)('metadata')
});
// RELATIONS
exports.userRelations = (0, drizzle_orm_1.relations)(exports.users, ({ many }) => ({
    posts: many(exports.posts),
    comments: many(exports.comments),
    sentMessages: many(exports.messages, { relationName: 'sender' }),
    receivedMessages: many(exports.messages, { relationName: 'receiver' }),
    notifications: many(exports.notifications),
    likes: many(exports.likes)
}));
exports.postRelations = (0, drizzle_orm_1.relations)(exports.posts, ({ one, many }) => ({
    user: one(exports.users, { fields: [exports.posts.userId], references: [exports.users.id] }),
    comments: many(exports.comments)
}));
exports.commentRelations = (0, drizzle_orm_1.relations)(exports.comments, ({ one }) => ({
    user: one(exports.users, { fields: [exports.comments.userId], references: [exports.users.id] }),
    post: one(exports.posts, { fields: [exports.comments.postId], references: [exports.posts.id] })
}));
exports.messageRelations = (0, drizzle_orm_1.relations)(exports.messages, ({ one }) => ({
    from: one(exports.users, { fields: [exports.messages.from], references: [exports.users.id], relationName: 'sender' }),
    to: one(exports.users, { fields: [exports.messages.to], references: [exports.users.id], relationName: 'receiver' })
}));
exports.notificationRelations = (0, drizzle_orm_1.relations)(exports.notifications, ({ one }) => ({
    user: one(exports.users, { fields: [exports.notifications.userId], references: [exports.users.id] })
}));
exports.likeRelations = (0, drizzle_orm_1.relations)(exports.likes, ({ one }) => ({
    user: one(exports.users, { fields: [exports.likes.userId], references: [exports.users.id] }),
    post: one(exports.posts, { fields: [exports.likes.postId], references: [exports.posts.id] })
}));
